var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header-top"},[_c('div',{staticClass:"title-app"},[_c('Widget',{attrs:{"position":"main_title"}})],1),_c('Navigation')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }